import CustomDialog from "components/Atoms/CustomDialog"
import Divider from "components/Atoms/Divider"
import CollapseCard from "components/Molecules/CollapseCard"
import { PAYMENT_METHODS } from "data/static.items"
import { useBeatVisitDetailLazyQuery } from "generated/graphql"
import { groupBy, isEmpty, startCase } from "lodash-es"
import React, { useEffect, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { inr } from "utils/formatters.utils"

// const sections = [
//   {
//     title: "Return Request",
//     content: (
//       <>
//         <OrderItem
//           title={"Pineapple Queen Large 12 Pcs Crate"}
//           quantity={2}
//           batch="90909091"
//           price={2500}
//         />
//         <Divider dashed className="my-2" />
//         <OrderItem
//           title={"Mango Drink 32 Piece box"}
//           quantity={7}
//           batch="90909092"
//           price={1500}
//         />
//       </>
//     ),
//   },
//   {
//     title: "Pickup Order",
//     content: (
//       <>
//         <OrderItem
//           title={"Pineapple Queen Large 12 Pcs Crate"}
//           quantity={2}
//           batch="90909091"
//           price={2500}
//         />
//         <Divider dashed className="my-2" />
//         <OrderItem
//           title={"Mango Drink 32 Piece box"}
//           quantity={7}
//           batch="90909092"
//           price={1500}
//         />
//       </>
//     ),
//   },
//   {
//     title: "Payment Collection",
//     content: (
//       <div className="flex justify-between text-gray-700">
//         <div>
//           <div className="text-gray-500">Order</div>
//           <div className="underline">Order ID</div>
//         </div>
//         <div>
//           <div className="text-gray-500">Payment Method</div>
//           <div>Cash</div>
//         </div>
//         <div>
//           <div className="text-gray-500">Amount</div>
//           <div>{inr(2500)}</div>
//         </div>
//       </div>
//     ),
//   },
//   {
//     title: "Orders placed",
//     content: (
//       <>
//         <OrderItem title={"Order ID"} quantity={2} price={1500} status="Paid" />
//         <Divider dashed className="my-2" />
//         <OrderItem title={"Order ID"} quantity={2} price={1500} status="Paid" />
//       </>
//     ),
//   },
//   {
//     title: "Attachment",
//     content: (
//       <>
//         <div className="grid grid-cols-5 gap-2 mb-2">
//           {times(5).map(time => {
//             return (
//               <img
//                 className="h-full w-full rounded-md shadow"
//                 src={`https://picsum.photos/seed/${uniqueId()}/1000/700`}
//                 alt={time.toString()}
//               />
//             )
//           })}
//         </div>
//         <h6 className="m-0 text-sm text-gray-700">Remark: Content Written</h6>
//       </>
//     ),
//   },
// ]

const OrderItem = ({ title, quantity, batch = null, price, status = null }) => {
  return (
    <div className="flex justify-between">
      <div className="text-xs">
        <div className="text-gray-700">{title}</div>
        <div className="text-gray-500">{quantity} Unit</div>
        {batch && <div className="text-gray-600">Batch Code : {batch}</div>}
      </div>
      <div>
        <div className="text-gray-800">{inr(price)}</div>
        {status && <div className="text-green text-xs">{status}</div>}
      </div>
    </div>
  )
}

function renderContent(type: string, data: any) {
  switch (type) {
    case "return_request":
      return (
        <>
          {data.map((order, idx) => {
            const details = JSON.parse(order.actionDetails)?.action?.variables

            return (
              <React.Fragment key={idx}>
                <OrderItem
                  title={details.sellable_item_name}
                  quantity={details.quantity}
                  price={details.amount}
                  batch={details.batch_code}
                />
                {idx !== data.length - 1 && <Divider dashed className="my-2" />}
              </React.Fragment>
            )
          })}
        </>
      )
    case "pickup_order":
      return (
        <>
          {data.map((order, idx) => {
            const details = JSON.parse(order.actionDetails)?.action?.variables

            return (
              <React.Fragment key={idx}>
                <OrderItem
                  title={details.sellable_item_name}
                  quantity={details.quantity}
                  price={details.amount}
                  batch={details.batch_code}
                />
                {idx !== data.length - 1 && <Divider dashed className="my-2" />}
              </React.Fragment>
            )
          })}
        </>
      )
    case "payment_collection":
      return (
        <table className="text-gray-700 text-left font-400 w-full">
          <thead>
            <tr className="text-gray-500">
              <th className="font-400">Order</th>
              <th className="font-400 text-right">Payment Method</th>
              <th className="font-400 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {data?.map(action => {
              const details = JSON.parse(action.actionDetails)?.action
                ?.variables
              return (
                <tr key={action.id}>
                  <td>{details.order_id}</td>
                  <td className="text-right">
                    {
                      PAYMENT_METHODS.find(p => p.id === details.payment_method)
                        .name
                    }
                  </td>
                  <td className="text-right">{inr(details.amount)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )
    case "placed_order":
      return (
        <>
          {data.map((order, idx) => {
            const details = JSON.parse(order.actionDetails)?.action?.variables

            return (
              <React.Fragment key={idx}>
                <OrderItem
                  title={`Order #${details.order_id}`}
                  quantity={details.lines_sold}
                  price={details.amount}
                />
                {idx !== data.length - 1 && <Divider dashed className="my-2" />}
              </React.Fragment>
            )
          })}
        </>
      )
    case "attachments":
      return (
        <>
          <div className="grid grid-cols-5 gap-2 mb-2">
            {data?.attachments?.map(img => {
              return (
                <img
                  key={img.id}
                  className="h-full w-full rounded-md shadow"
                  src={img.url}
                  alt={img.id}
                />
              )
            })}
          </div>
          <h6 className="m-0 text-sm text-gray-700">
            Remark: {data?.remark || "na"}
          </h6>
        </>
      )

    default:
      return null
  }
}

const VisitDetails = () => {
  const [params, setParams] = useSearchParams()
  const visitId = params.get("visit")
  const name = params.get("name")
  const [fetch, { data, loading }] = useBeatVisitDetailLazyQuery()
  const actionItems = data?.beatVisitDetail?.actions
  const remark = data?.beatVisitDetail?.remark
  const attachments = data?.beatVisitDetail?.attachments
  useEffect(() => {
    if (parseInt(visitId)) {
      fetch({ variables: { id: visitId } })
    }
  }, [fetch, visitId])

  const actions = useMemo(
    () => ({
      ...groupBy(actionItems, "action"),
      attachments: {
        remark,
        attachments,
      },
    }),
    [actionItems, remark, attachments]
  )

  return (
    <CustomDialog
      className="bg-gray-100 max-h-full"
      onClose={() => setParams({})}
      title={`Visitee - ${name || "na"}`}
      isOpen={visitId ? true : false}
    >
      {loading
        ? null
        : !data?.beatVisitDetail
        ? null
        : !isEmpty(actions) &&
          Object.keys(actions).map(action => {
            return (
              <CollapseCard
                key={action}
                title={startCase(action)}
                className="shadow-none rounded mb-3 last:mb-0"
                headerClassName={"bg-yellow-100"}
              >
                <div className="p-2">
                  {renderContent(action, actions[action])}
                </div>
              </CollapseCard>
            )
          })}
    </CustomDialog>
  )
}

export default VisitDetails
